export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "worker.f9b9eb5ef9ec0a47be35.worker.js");
}
